import { gql, LazyQueryResultTuple, useLazyQuery, useQuery } from '@apollo/client'
import { Telemetry } from '@ui/__generated__/graphql'
import { QueryParams } from '@ui/interfaces'

const TelemetryQueryQL = gql(`
  query Telemetry($queryParams: QueryParams) {
    telemetry(queryParams: $queryParams) {
      events {
        record
        metadata {
          datatype
          span_id
          trace_id
          batch_identifier
          batch_index
        }
      }
      totals {
        count
        size
      }
      uniqueKeys {
        count
        key
        size
      }
    }
  }
`)

const TopValuesQueryQL = gql(`
  query TopValues($queryParams: QueryParams, $key: String!, $n: Int) {
    telemetry(queryParams: $queryParams) {
      topValues(key: $key, n: $n) {
        count
        key
        size
        value
      }
    }
  }
`)

export function TelemetryQuery({
  from,
  startTime,
  endTime,
  where = '',
  limit = 100,
  offset = 0,
  nodeId = null,
  skip = false,
}: {
  from: string
  startTime: Date
  endTime: Date
  where: string
  limit?: number
  offset?: number
  nodeId?: string | null
  skip?: boolean
}) {
  return useQuery(TelemetryQueryQL, {
    variables: {
      queryParams: {
        endTime,
        from,
        limit,
        offset,
        startTime,
        where,
        nodeId: nodeId || null,
      },
    },
    fetchPolicy: 'network-only',
    skip: skip,
  })
}

export const TelemetryLazyQuery = (): LazyQueryResultTuple<
  { telemetry: Telemetry },
  { queryParams: QueryParams & { nodeId?: string | null } }
> => useLazyQuery(TelemetryQueryQL, { fetchPolicy: 'network-only' })

export function TopValuesQuery({
  key,
  from,
  startTime,
  endTime,
  where = '',
  n = 5,
  limit = 100,
  offset = 0,
  nodeId = null,
  skip = false,
}: {
  key: string
  from: string
  startTime: Date
  endTime: Date
  where: string
  n?: number
  limit?: number
  offset?: number
  nodeId?: string | null
  skip?: boolean
}) {
  return useQuery(TopValuesQueryQL, {
    variables: {
      queryParams: {
        endTime,
        from,
        limit,
        offset,
        startTime,
        where,
        nodeId: nodeId || null,
      },
      key,
      n,
    },
    fetchPolicy: 'network-only',
    skip: skip,
  })
}
